import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { PatientService, User, UserService } from '../../shared';

@Component({
  selector: 'app-recoverycoach',
  templateUrl: './recoverycoach.component.html',
  styleUrls: ['../style.component.css', './recoverycoach.component.css']
})
export class RecoverycoachComponent implements OnInit {
  public timealert = environment.timelimit;
  show: boolean;
  patid: any;
  welcome: any;
  ip: any;
  public account: any;
  public Patpro = {
    otpassword: "",
    otpState: ""
  }
  modalRef: any;
  resdata: any;
  ipaddress: any = {};
  currentUser: User
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
  }
  constructor(
    private patientservice: PatientService,
    private routerr: ActivatedRoute,
    private route: Router,
    private toast: ToastrService,
    private modalService: BsModalService,
    private userService: UserService,
    private nav: Router
  ) { }

  ngOnInit() {


    this.routerr.params.subscribe(params => {
      this.patid = params
      this.patientservice.changeNav(params['id'])
      this.patid = params['id']
      ////////console.log(this.patid);
    });
    this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
        if (this.routerr.snapshot.url[0].path == 'recovery') {
          this.currentUser.status = true
        }
        //this.userService.currentUserSubject.next(this.currentUser);

      }
    )
    this.userService
      .getip()
      .subscribe(
        data => {

          //////console.log(data);



          if (data.usersIPCaptureDetails == "") {

            this.ipaddress = data;
            ////console.log(data)
            this.ip = data.IpAddressCap;
            this.account = data.logInAccountId;
            ////console.log(this.account)
            this.getaccount(this.account, "Email & SMS Sent successfully")


          }
          else {
            this.ipaddress = data;
            ////console.log(data)
            this.ip = data.IpAddressCap;
            this.account = data.usersIPCaptureDetails[0].userAccountId;
            ////console.log(this.account)
            this.getaccount(this.account, "Please enter the OTP that was sent to your Email and/or Mobile")
          }

        }
      );



  }

  getaccount(account, msg) {
    this.patientservice
      .getaccount(this.account)
      .subscribe(
        data => {
          if (data.status == "success") {
            ////console.log("message sent")
            this.toast.success(msg, '', {
              timeOut: this.timealert
            })
          }
        }
      )
  }


  resend() {

    this.patientservice
      .getaccount(this.account)
      .subscribe(
        data => {
          if (data.status == "success") {
            ////console.log("message sent")
            this.toast.success("OTP sent successfully", '', {
              timeOut: this.timealert
            })
          }
          else {
            this.toast.error("OTP not sent", '', {
              timeOut: this.timealert
            })
          }
        }
      )

  }



  otp(msg) {
    ////console.log(msg.value)
    if (msg.value.otpState == "") {
      msg.value.otpState = false;
    }
    let sms = {
      "userAccountId": this.account,
      "ipAddress": this.ip,
      "otpState": msg.value.otpState,
      "otpassword": msg.value.otpassword
    }
    ////console.log(sms)
    this.patientservice
      .getotpuser(sms)
      .subscribe(
        data => {
          if ((data.status == "success") && (data.messasge == "OTP Matched!")) {
            ////console.log("page")
            this.nav.navigateByUrl('/care/mytodo')

            this.currentUser.status = false
          }
          else if ((data.status == "success") && (data.otpStatus == "OTP Not Matched!")) {
            this.toast.error("OTP Not Matched!", '', {
              timeOut: this.timealert
            })
          }
          else if ((data.status == "false") && (data.messasge == "Time Expried!")) {
            this.toast.error("Time Expried!", '', {
              timeOut: this.timealert
            })
          }
          else if ((data.status == "success") && (data.otpStatus == "Not a Same User!")) {
            this.toast.error("Try again later", '', {
              timeOut: this.timealert
            })
            this.nav.navigateByUrl('/login')
          }
        }
      )

  }



  toggleShow(event, id, inputid) {
    this.show = !this.show;

    if (this.show) {
      $(`#${id}`).removeClass('fa-eye')
      $(`#${id}`).addClass('fa-eye-slash')
      let input = $(`#${inputid}`);
      input.attr('type', 'text')
    }
    else {
      $(`#${id}`).removeClass('fa-eye-slash')
      $(`#${id}`).addClass('fa-eye')
      let input = $(`#${inputid}`);
      input.attr('type', 'password')

    }
  }





  // addpat(result){

  //   this.patientservice
  //   .getwelcome(this.patid)
  //   .subscribe(
  //     data => 
  //     {


  //       if(data.userInfo.status == "success") {

  //       this.nav.navigate([`/createnewpass/${this.patid}`])
  //        } 
  //        else{
  //         this.resdata = "You have already registered";
  //         this.modalRef = this.modalService.show(result, {class: 'modal-sm'});

  //        }
  //     }      
  //   );

  // }
  // link(){
  //   this.userService.currentUser.subscribe(
  //     (userData) => {
  //       this.currentUser = userData;

  //         this.currentUser.status = false

  //       this.userService.currentUserSubject.next(this.currentUser);
  //       this.route.navigateByUrl('/care/mytodo')

  //     }
  //   )
  // }
}
